// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"601":"component---src-pages-index-mdx","865":"component---src-pages-404-mdx"}[chunkId] || chunkId) + "-" + {"601":"ed7a4a30e709aeb48c7b","645":"e9d5e3d12025ec1ed5c7","865":"63797935b5fca9bb7686"}[chunkId] + ".js";
};